// import React, { useRef } from "react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import axios from "axios";
import pranamheader from "../assests/pranamheader.png";
// const materialColors = {
//   background: "#263238", // Blue Grey 900
//   cardBackground: "#37474f", // Blue Grey 800
//   primary: "#ffca28", // Amber 400 (for highlights)
//   textPrimary: "#eceff1", // Blue Grey 50
//   textSecondary: "#b0bec5", // Blue Grey 200
//   border: "#ffc107", // Amber 500
//   buttonBackground: "#ffc107", // Amber 500
//   buttonText: "#263238", // Blue Grey 900
// };

// const Test1 = () => {
//   const formRef = useRef(null);

//   const formData = {
//     full_name: "John Doe",
//     gender: "Male",
//     age: "32",
//     date_of_birth: "1993-08-15",
//     contact_number: "9876543210",
//     height_cm: "175",
//     weight_kg: "70",
//     bmi: "22.9",
//     body_fat_percent: "18%",
//     visceral_fat_level: "10",
//     body_age: "28",
//     resting_metabolism_kcal: "1600",
//     concern: "Fatigue and weight fluctuation",
//     observation: "Healthy weight and BMI within normal range.",
//     suggestion: "Maintain regular exercise and hydration.",
//     doctor_name: "Dr. Neha Kapoor",
//   };

//   const generatePDFAndUpload = async () => {
//     const input = formRef.current;

//     try {
//       const canvas = await html2canvas(input, {
//         scale: 2,
//         useCORS: true,
//       });

//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "mm", "a4");
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
//       pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
//       const pdfBlob = pdf.output("blob");

//       const formDataToUpload = new FormData();
//       formDataToUpload.append("pdf_file", pdfBlob, "bmi_report.pdf");

//       await axios.post(
//         "https://feedback.pranaamhospitals.com/index.php/BMI/bmi_assessment",
//         formDataToUpload,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       alert("PDF uploaded successfully!");
//     } catch (error) {
//       alert("Error generating or uploading PDF");
//     }
//   };

//   return (
//     <div
//       style={{
//         // backgroundColor: materialColors.background,
//         padding: "40px",
//         minHeight: "100vh",
//         color: materialColors.textPrimary,
//         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       }}
//     >
//       <div
//         ref={formRef}
//         style={{
//           maxWidth: "800px",
//           margin: "auto",
//           backgroundColor: materialColors.cardBackground,
//           padding: "40px",
//           borderRadius: "12px",
//           boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
//           color: materialColors.textSecondary,
//           fontFamily: "'Montserrat', sans-serif",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             borderBottom: `2px solid ${materialColors.border}`,
//             paddingBottom: "20px",
//             marginBottom: "30px",
//           }}
//         >
//             <img src={pranamheader} alt="prannam-header"/>
//           <h1
//             style={{
//               fontSize: "36px",
//               color: materialColors.primary,
//               fontWeight: 600,
//               marginBottom: "10px",
//               letterSpacing: "1px",
//             }}
//           >
//             BMI Report
//           </h1>
//         </div>

//         {/* Patient Info */}
//         {/* Patient Info - Two Columns */}
// <div
//   style={{
//     marginBottom: "30px",
//     display: "grid",
//     gridTemplateColumns: "repeat(2, 1fr)",
//     // gap: "20px",
//   }}
// >
//   {[
//     ["Patient Name", formData.full_name],
//     ["Gender", formData.gender],
//     ["Age", formData.age],
//     ["Date of Birth", formData.date_of_birth],
//     ["Contact Number", formData.contact_number],
//   ].map(([label, value]) => (
//     <p
//       key={label}
//       style={{
//         fontSize: "15px",
//         margin: "8px 0",
//         color: materialColors.textSecondary,
//         display: "flex",
//         gap: "6px",
//         alignItems: "center",
//       }}
//     >
//       <strong
//         style={{
//           color: materialColors.primary,
//           width: "200px", // fixed width to align labels
//           display: "inline-block",
//           margin_bottom: '30px',
//         }}
//       >
//         {label}:
//       </strong>
//       <span style={{ color: materialColors.textPrimary }}>{value || "N/A"}</span>
//     </p>
//   ))}
// </div>


//         {/* Measurements Table */}
//         <div style={{ marginBottom: "30px" }}>
//           <h2
//             style={{
//               fontSize: "20px",
//               // color: materialColors.primary,
//               color:"black",
//               marginBottom: "16px",
//             }}
//           >
//             Body Composition
//           </h2>
//           <table style={{ width: "100%", borderCollapse: "collapse" }}>
//             <tbody>
//               {[
//                 ["Height (cm)", formData.height_cm],
//                 ["Weight (kg)", formData.weight_kg],
//                 ["BMI", formData.bmi],
//                 ["Body Fat Percent", formData.body_fat_percent],
//                 ["Visceral Fat Level", formData.visceral_fat_level],
//                 ["Body Age", formData.body_age],
//                 ["Resting Metabolism (kcal)", formData.resting_metabolism_kcal],
//               ].map(([label, value]) => (
//                 <tr
//                   key={label}
//                   style={{ borderBottom: `1px solid ${materialColors.background}` }}
//                 >
//                   <td style={{ padding: "10px 0", color: materialColors.textSecondary }}>
//                     {label}
//                   </td>
//                   <td
//                     style={{
//                       padding: "10px 0",
//                       color: materialColors.textPrimary,
//                       textAlign: "right",
//                     }}
//                   >
//                     {value || "N/A"}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Observations */}
//         <div style={{ marginBottom: "30px" }}>
//           {[
//             ["Concern", formData.concern],
//             ["Observation", formData.observation],
//             ["Suggestion", formData.suggestion],
//             ["Doctor Name", formData.doctor_name],
//           ].map(([label, value]) => (
//             <div key={label} style={{ marginBottom: "10px" }}>
//               <p style={{ fontSize: "15px", lineHeight: 1.6 }}>
//                 <strong style={{ color: materialColors.primary }}>{label}:</strong>{" "}
//                 {value || "N/A"}
//               </p>
//             </div>
//           ))}
//         </div>

//         {/* Footer Thank You */}
//       {/* Footer Copyright */}
// <footer
//   style={{
//     textAlign: "center",
//     marginTop: "40px",
//     padding: "20px 0",
//     fontSize: "14px",
//     color: "rgb(246 236 236)", // subtle gray color
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//   }}
// >
//   © Copyrights 2024 Pranaam Hospitals — All rights reserved
// </footer>

//       </div>
//     </div>
//   );
// };

// export default Test1;


import React, { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import pranam from "../assests/Pranam-Logo.png";
// import pranamheader from "../assests/671cd926-bec0-4dfc-9f7a-c068fd81b63e.png"; // updated image path

const materialColors = {
  background: "#ffffff",
  cardBackground: "#ffffff",
  headingColor: "#d32f2f", // Dark Red for headings
  textPrimary: "#000000",
  textSecondary: "#333333",
  border: "#ccc",
  buttonBackground: "#ffc107",
  buttonText: "#263238",
};

const Test1 = () => {
  const formRef = useRef(null);

  const formData = {
    full_name: "John Doe",
    gender: "Male",
    age: "32",
    date_of_birth: "1993-08-15",
    contact_number: "9876543210",
    height_cm: "175",
    weight_kg: "70",
    bmi: "22.9",
    body_fat_percent: "18%",
    visceral_fat_level: "10",
    body_age: "28",
    resting_metabolism_kcal: "1600",
    concern: "Fatigue and weight fluctuation",
    observation: "Healthy weight and BMI within normal range.",
    suggestion: "Maintain regular exercise and hydration.",
    doctor_name: "Dr. Neha Kapoor",
  };

  // const generatePDFAndUpload = async () => {
  //   const input = formRef.current;
  //   try {
  //     const canvas = await html2canvas(input, {
  //       scale: 2,
  //       useCORS: true,
  //     });

  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

  //     const pdfBlob = pdf.output("blob");

  //     const formDataToUpload = new FormData();
  //     formDataToUpload.append("pdf_file", pdfBlob, "bmi_report.pdf");

  //     // Upload to API
  //     await axios.post(
  //       "https://feedback.pranaamhospitals.com/index.php/BMI/bmi_assessment",
  //       formDataToUpload,
  //       { headers: { "Content-Type": "multipart/form-data" } }
  //     );

  //     // ✅ Download the PDF locally
  //     pdf.save("bmi_report.pdf");

  //     alert("PDF uploaded and downloaded successfully!");
  //   } catch (error) {
  //     alert("Error generating or uploading/downloading PDF");
  //     console.error(error);
  //   }
  // };

  const generatePDFAndUpload = async () => {
    const input = formRef.current;
    if (!input) {
      alert("Content not found");
      return;
    }

    try {
      const canvas = await html2canvas(input, {
        scale: 1,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      // First page
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      // Add remaining pages
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      // Save PDF
      pdf.save("bmi_report.pdf");

      alert("PDF successfully generated.");
    } catch (error) {
      console.error("PDF generation error:", error);
      alert("Failed to generate PDF.");
    }
  };



  return (
    <div
      style={{
        backgroundColor: materialColors.background,
        // padding: "40px",
        minHeight: "100vh",
        color: materialColors.textPrimary,
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        ref={formRef}
        style={{
          maxWidth: "800px",
          margin: "auto",
          backgroundColor: materialColors.cardBackground,
          padding: "40px",
          borderRadius: "12px",
          border: `1px solid ${materialColors.border}`,
          color: materialColors.textPrimary,
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        {/* Header */}
        <div
          style={{
            borderBottom: `2px solid ${materialColors.border}`,
            // paddingBottom: "20px",
            marginBottom: "10px",
          }}
        >
          <img
            // src={pranamheader}
            src={pranam}
            alt="Pranaam Header"
            style={{ width: "auto", height: "50px", objectFit: "contain" }}
          />
          <h1
            style={{
              fontSize: "22px",
              color: "rgb(139, 29, 29)",
              fontWeight: "600",
              // marginTop: "20px",
              letterSpacing: "1px",
            }}
          >
            BMI Report
          </h1>
        </div>

        {/* Patient Info */}
        <div
          style={{
            marginLeft: '16px',
            color: "black",
            display: "flex",
            flexDirection:'row',
            gap:'20px'
          }}
        >
          {[
            ["Patient Name", formData.full_name],
          ].map(([label, value]) => (
            <p
              key={label}
              style={{
                fontSize: "14px",
                margin: "8px 0",
                color: materialColors.textSecondary,
                display: "flex",
                gap: "16px",
                alignItems: "center",
              }}
            >
              <strong
                style={{
                  color: "rgb(139, 29, 29)",
                  width: "160px",
                  display: "inline-block",
                }}
              >
                {label}:
              </strong>
              <span>{value || "N/A"}</span>
            </p>
          ))}
        </div>
        <div
          style={{
            marginLeft: '16px',
            color: "black",
            display: "flex",
            // gridTemplateColumns: "repeat(2, 1fr)",
            flexDirection:"row",
            gap:"100px"
          }}
        >
          {[
            ["Gender", formData.gender],
            ["Age", formData.age],
          ].map(([label, value]) => (
            <p
              key={label}
              style={{
                fontSize: "14px",
                margin: "8px 0",
                color: materialColors.textSecondary,
                display: "flex",
                gap: "16px",
                alignItems: "center",
              }}
            >
              <strong
                style={{
                  color: "rgb(139, 29, 29)",
                  width: "160px",
                  display: "inline-block",
                }}
              >
                {label}:
              </strong>
              <span>{value || "N/A"}</span>
            </p>
          ))}
        </div>
        <div
          style={{
            marginLeft: '16px',
            color: "black",
            display: "flex",
            // gridTemplateColumns: "repeat(2, 1fr)",
            flexDirection:"row",
            gap:"60px"
          }}
        >
          {[
            ["Date of Birth", formData.date_of_birth],
            ["Contact Number", formData.contact_number],
          ].map(([label, value]) => (
            <p
              key={label}
              style={{
                fontSize: "14px",
                margin: "8px 0",
                color: materialColors.textSecondary,
                display: "flex",
                gap: "16px",
                alignItems: "center",
              }}
            >
              <strong
                style={{
                  color: "rgb(139, 29, 29)",
                  width: "160px",
                  display: "inline-block",
                }}
              >
                {label}:
              </strong>
              <span>{value || "N/A"}</span>
            </p>
          ))}
        </div>

        {/* Measurements Table */}
        <div style={{ marginBottom: "10px" }}>
          <h2
            style={{
              marginLeft: '10px',
              fontSize: "13px",
              color: "rgb(139, 29, 29)",
              marginBottom: "16px",
            }}
          >
            Body Composition
          </h2>
          <table style={{ width: "100%", borderCollapse: "collapse", marginLeft: '16px', fontSize: 'bold' }}>
            <tbody>
              {[
                ["Height (cm)", formData.height_cm],
                ["Weight (kg)", formData.weight_kg],
                ["BMI", formData.bmi],
                ["Body Fat Percent", formData.body_fat_percent],
                ["Visceral Fat Level", formData.visceral_fat_level],
                ["Body Age", formData.body_age],
                ["Resting Metabolism (kcal)", formData.resting_metabolism_kcal],
              ].map(([label, value]) => (
                <tr
                  key={label}
                  style={{ borderBottom: `1px solid ${materialColors.border}`, fontSize: '14px' }}
                >
                  <td style={{ padding: "5px 0", color: materialColors.textSecondary }}>
                    {label}
                  </td>
                  <td
                    style={{
                      padding: "10px 0",
                      color: materialColors.textPrimary,
                      textAlign: "right",
                    }}
                  >
                    {value || "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Observations */}
        <div style={{ marginBottom: "20px", display: 'grid', flexDirection: 'column', gap: '10px', marginLeft: '16px', }}>
          {[
            ["Concern", formData.concern],
            ["Observation", formData.observation],
            ["Suggestion", formData.suggestion],
            ["Doctor Name", formData.doctor_name],
          ].map(([label, value]) => (
            <div key={label}>
              <p style={{ fontSize: "14px", lineHeight: 1.6 }}>
                <strong style={{ color: "rgb(139, 29, 29)" }}>{label}:</strong>{" "}
                {value || "N/A"}
              </p>
            </div>
          ))}
        </div>
        <button type="submit" onClick={generatePDFAndUpload}>Submit and Download PDF</button>


        <footer className="text-sm w-full">
        <div className="mt-2 text-gray-600 text-center mb-2">
              <p className="font-semibold text-black">Dr. Aarti</p>
              <p className="font-semibold text-black">Physiotherapist, Clinical Nutritionist, Natural Birthing Expert & Yoga Therapist</p>
              <p className="font-semibold text-black">Phone: 8106766066</p>
            </div>
          <div className="mt-4 text-center text-sm text-black font-semibold shadow-sm bt-2"  style={{borderTop:'1px solid black'}}>
            <p style={{marginTop:'10px'}}>© {new Date().getFullYear()} Pranaam Hospitals. All rights reserved.</p>
          </div>
        </footer>

      </div>
    </div>
  );
};

export default Test1;
